import React, { CSSProperties } from 'react';
import * as styles from './index.module.less';

interface IProps {
  ratio: number;
  children?: React.ReactNode;
  className?: string;
}

const AspectRatioBox = ({ ratio = 1, children, className = '' }: IProps) => {
  const paddingTop = `${(1 / ratio) * 100}%`;

  return (
    <div style={{ '--pt': paddingTop } as CSSProperties} className={`${styles.outer} ${className}`}>
      <div className={styles.inner}>{children}</div>
    </div>
  );
};
export default AspectRatioBox;
